/*** IMPORTS FROM imports-loader ***/
var require = window.require;

/**
 * For bundle configuration, see require.config.bundles.js, and for usage, see http://requirejs.org/docs/api.html#config-bundles.
 * The bundle config was separated from this main config in order to load this file as "mainConfigFile" in the optimizer.
 * If a bundle config is present when the optimizer runs, it tries to load modules by the bundles' names and results in errors.
 * The bundles are only needed at runtime, not for build optimization, since they will be created by the optimizer.
 */
require.config({
  paths: {
    '@bingads-webui'              : 'clientcenter/@bingads-webui',
    '@bingads-webui-react'        : 'clientcenter/@bingads-webui-react',
    '@bingads-webui-universal'    : 'clientcenter/@bingads-webui-universal',
    '@bingads-webui-clientcenter' : 'clientcenter/@bingads-webui-clientcenter',
    '@bingads-webui-cc-react'     : 'clientcenter/@bingads-webui-cc-react',
    '@bingads-webui-cc-feature'   : 'clientcenter/@bingads-webui-cc-feature',
    '@bingads-webui-campaign'     : 'clientcenter/@bingads-webui-campaign',
    '@bingads-webui-campaign-react' : 'clientcenter/@bingads-webui-campaign-react',
    '@bingads-webui-theme-2018'   : 'clientcenter/@bingads-webui-theme-2018',
    '@bingads-webui-grid'         : 'clientcenter/@bingads-webui-grid',
    '@cspayments'                 : 'clientcenter/@cspayments',
  },
  map: {
    '*': {
      'Cookie'                                : 'component/cookie',
      'backbone-toolbar'                      : 'component/github/backbone-toolbar',
      'backbone-virtualized-listview'         : 'component/github/backbone-virtualized-listview',
      'fast-binary-indexed-tree'              : 'component/github/fast-binary-indexed-tree',
      'projection-grid'                       : 'component/github/projection-grid',
      'lib/int/jade/jade-util'                : 'component/jade/util',
      'StateManager/CampaignStateManager'     : 'component/statemanager/campaignStateManager',
      // CCUI has a indirect require dependency on statemanager. Now statemanager has a dependency on preferences to do data migration from statemanager to preferences service.
      // A mock dependency is added during the data migration process. An actual implementation will follow once data is migrated and we start onboarding to preferences.
      'component/preference/service/index'    : 'component/statemanager/mock-preferences',
      'MemoryStorage'                         : 'component/storage/memoryStorage',
      'LocalStorage'                          : 'component/storage/localStorage',
      'SessionStorage'                        : 'component/storage/sessionStorage',
      'module/service/instrumentation/index'  : 'instrumentation/log',
      'react-jss'                             : 'lib-clientcenter/react-jss',
      'axios'                                 : 'lib/axios',
      'backbone'                              : 'lib/backbone',
      'base64-arraybuffer'                    : 'lib/base64-arraybuffer',
      'bluebird'                              : 'lib/bluebird',
      'brcast'                                : 'lib/brcast',
      'browser-cookies'                       : 'lib/browser-cookies',
      'bootstrap'                             : 'lib/bootstrap',
      'classnames'                            : 'lib/classnames',
      'cldrjs'                                : 'lib/cldrjs',
      'create-react-context'                  : 'lib/create-react-context-polyfill/index',
      'css-line-break'                        : 'lib/css-line-break',
      'css-vendor'                            : 'lib/css-vendor',
      'decode-uri-component'                  : 'lib/decode-uri-component',
      'dom-helpers'                           : 'lib/dom-helpers',
      'exenv'                                 : 'lib/exenv',
      'globalize'                             : 'lib/globalize',
      'history'                               : 'lib/history',
      'hoist-non-react-statics'               : 'lib/hoist-non-react-statics',
      'hotkeys-js'                            : 'lib/hotkeys-js',
      'html2canvas'                           : 'lib/html2canvas',
      'hyphenate-style-name'                  : 'lib/hyphenate-style-name',
      'invariant'                             : 'lib/invariant',
      'iana-tz-data'                          : 'lib/iana-tz-data',
      'is-function'                           : 'lib/is-function',
      'is-plain-object'                       : 'lib/is-plain-object',
      'isarray'                               : 'lib/isarray',
      'isobject'                              : 'lib/isobject',
      'jquery'                                : 'lib/jquery',
      'js-data'                               : 'lib/js-data',
      'js-data-localstorage'                  : 'lib/js-data-localstorage',
      'json'                                  : 'lib/json',
      'json-stable-stringify'                 : 'lib/json-stable-stringify',
      'json2mq'                               : 'lib/json2mq',
      'jsonify'                               : 'lib/jsonify',
      'knockout'                              : 'lib/knockout',
      'keycode'                               : 'lib/keycode',
      'levenshtein-edit-distance'             : 'lib/levenshtein-edit-distance',
      'object-assign'                         : 'lib/object-assign',
      'scheduler'                             : 'lib/scheduler',
      'path-browserify'                       : 'lib/path-browserify',
      'path-to-regexp'                        : 'lib/path-to-regexp',
      'prop-types'                            : 'lib/prop-types',
      'prop-types-extra'                      : 'lib/prop-types-extra',
      'pug-runtime'                           : 'lib/pug-runtime',
      'popper.js'                             : 'lib/popper',
      'query-string'                          : 'lib/query-string',
      'kendo'                                 : 'lib/shim/kendo',
      'underscore'                            : 'lib/underscore',
      'underscore.string'                     : 'lib/underscore.string',
      'urijs'                                 : 'lib/urijs',
      'requirejs'                             : 'require',
      'react'                                 : 'lib/react',
      'react-bootstrap'                       : 'lib/react-bootstrap',
      'react-dom'                             : 'lib/react-dom',
      'react-display-name'                    : 'lib/react-display-name',
      'react-hot-keys'                        : 'lib/react-hot-keys',
      'react-is'                              : 'lib/react-is',
      'react-media'                           : 'lib/react-media',
      'react-router'                          : 'lib/react-router',
      'react-router-dom'                      : 'lib/react-router-dom',
      'react-onclickoutside'                  : 'lib/react-onclickoutside',
      'react-virtualized'                     : 'lib/react-virtualized',
      'react-visibility-sensor'               : 'lib/react-visibility-sensor',
      'react-modal'                           : 'lib/react-modal',
      'react-lifecycles-compat'               : 'lib/react-lifecycles-compat',
      'react-overlays'                        : 'lib/react-overlays',
      'react-popper'                          : 'lib/react-popper',
      'react-prop-types'                      : 'lib/react-prop-types',
      'react-transition-group'                : 'lib/react-transition-group',
      'reselect'                              : 'lib/reselect',
      'regenerator-runtime'                   : 'lib/regenerator-runtime',
      'strict-uri-encode'                     : 'lib/strict-uri-encode',
      'symbol-observable'                     : 'lib/symbol-observable',
      'tc39-proposal-temporal'                : 'lib-clientcenter/tc39-proposal-temporal',
      'tiny-invariant'                        : 'lib/tiny-invariant',
      'tiny-warning'                          : 'lib/tiny-warning',
      'tslib'                                 : 'lib/tslib',
      'warning'                               : 'lib/warning',
      'uuid'                                  : 'lib-clientcenter/uuid',
      'uuid/v4'                               : 'lib-clientcenter/uuid/v4',
      '@bingads-webui/primitive-utilities'    : '@bingads-webui-universal/primitive-utilities',
      'pagination-control'                    : 'component/github/pagination-control',
      // For leagcy requirejs bundle, we don't plan to port this to shared component version, basically the contents are the same.
      '@bingads-webui-component-legacy/github/modules/pagination-control/dist/pagination-control': 'component/github/pagination-control',
      'value-equal'                           : 'lib/value-equal',
      'resolve-pathname'                      : 'lib/resolve-pathname',
      '@bingads-webui/kendo'                  : 'lib/shim/kendo',
      'es6-promise/auto'                      : 'clientcenter/es6-promise',
      'isomorphic-fetch'                      : 'clientcenter/whatwg-fetch',
      'uncontrollable'                        : 'lib/uncontrollable',
      '@bingads-webui-react/fabric-control'   : 'lib/@bingads-webui-react/fabric-control',
      '@fluentui/react'                       : 'lib/@bingads-webui-react/fabric-control',
      '@fluentui'                             : 'lib/@fluentui',
      'onfido-sdk-ui'                         : 'lib/onfido-sdk-ui',
      'deepmerge'                             : 'lib/deepmerge',
      '@aria/webjs-sdk'                       : 'lib/@aria/webjs-sdk',
      'web-vitals'                            : 'lib/web-vitals',
      'component/config/index'                : '@bingads-webui-clientcenter/config',
    },
    '@bingads-webui': {
      'backbone-toolbar': 'component/github/backbone-toolbar',
      'underscore.string': 'lib/underscore.string',
    },
  },
  /**
   * Additional shim definitions are located under 'components/requirejs-shim'.
   * These are bundled into bingads-lib.js in the CCUI Gruntfile.js.
   * We should eventually drop dependency on those files and consolidate all of the shims to here.
   */
  shim: {
    'lib/jquery': {
      exports                     : '$'
    },
    'lib/jquery.utils': {
      deps                        : ['lib/jquery'],
      exports                     : '$.fn.ForceStringOnly'
    },
    'lib/underscore': {
      exports                     : '_'
    },
    'lib/knockout': {
      exports                     : 'ko'
    },
    '@cspayments/pidlsdk/pidlsdk': {
      deps                        : ['lib/jquery'],
      exports                     : 'pidl'
    },
    'lib/bluebird': {
      exports                     : 'Promise'
    },
    'lib/bootstrap': {
      deps                        : ['lib/jquery'],
      exports                     : '$.fn.popover'
    },
    'aria-web-telemetry': {
      exports: 'microsoft.applications.telemetry'
    }
  },
  config: {
    '@bingads-webui/cldr-data-loader': {
      paths: {
        core: 'json!@bingads-webui-universal/i18n-cldr-data-modern/core.json',
        locale: function (locale) {
          return 'json!@bingads-webui-universal/i18n-cldr-data-modern/locales/' + locale + '.json';
        },
      },
    },
  },
  onNodeCreated: function(node, config, name, url){
    node.setAttribute('crossorigin', 'anonymous');
  },
  waitSeconds: 0
});

